export default "__VITE_ASSET__3f42c89e__"